import React from 'react'
import Updrs_table from './updrs_table'
import {Table} from 'react-bootstrap'

class Part extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0}
    }
    handleScore = (val) => {
        if (!isNaN(val)){
            this.setState((prevState) => 
                        ({
                            ...prevState,
                            score:prevState.score + (val)

                        })
                        
            )
        }
        
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
           this.props.score (this.props.score_name,this.state.score)
        }
    }
    componentDidMount(){
        if(this.props.data!=null){
          
            if(this.props.data[this.props.indexKey+'_score'] == parseInt(this.props.data[this.props.indexKey+'_score'],10)){
                this.setState({score:parseInt(this.props.data[this.props.indexKey+'_score'],10)})
            }
            else{
                this.setState({score:0})
            }
           
        }
    }
    render(){
        
        return (
            <div>
            <h4>{this.props.title}</h4>
            <Updrs_table disabled={this.props.disabled}  part={this.props.indexKey}score={true} scoreFunc={this.handleScore} data={this.props.data!=null?this.props.data:null}  questions={this.props.questions} answers={this.props.questions} handler={this.props.onChange} fieldName={'fab'}/>
            {this.props.indexKey !='p4' && 
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Score:</th>
                                        <th width={100}>{this.state.score}</th>
                                    </tr>
                                </thead>
                            </Table>
                            
                            
                            }
            </div>
        )
    }
}
Part.defaultProps = {
    data:null,
    disabled:false
}

export default Part